import { render, staticRenderFns } from "./VerifyEmailWarningModal.vue?vue&type=template&id=1880168c&"
import script from "./VerifyEmailWarningModal.vue?vue&type=script&lang=ts&"
export * from "./VerifyEmailWarningModal.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyEmailWarningModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports